export default "/8522fe2631ecefb1e3967be9883671f05392a386/ed3e1222f5d7e466f1889a4510f1de5c.svg";